/**
 * Links Page
 */

export function Links() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-[#2F353D] mb-4">Links</h1>
      <p className="text-gray-600">Manage your links</p>
    </div>
  );
}
